import { useEffect, useState } from 'react'
import s from './InternalTeam.scss'
import Select from 'react-select'
import { Button } from 'reactstrap'
import { makeGetRequest } from 'utils/api'
import { toRoles } from './serializers'

const InternalTeam = ({
  removeInternalTeamUser,
  dealInternalTeam,
  changeUserCb,
  changeRoleCb,
  internalTeam,
  users,
  addInternalTeamUser
}) => {
  const [roles, setRoles] = useState([])

  useEffect(() => {
    ;(async () => {
      const response = await makeGetRequest('/v1/internalteamroles')
      setRoles(toRoles(response))
    })()
  }, [])

  return (
    <>
      <span className={s.title}>Internal Team:</span>{' '}
      <i className={s.subtitle}>People who will work on this and their role for the opportunity.</i>
      <div className={s.internalTeamWrapper}>
        {dealInternalTeam?.length > 0 && (
          <div className={s.internalTeamList}>
            {dealInternalTeam.map(user => (
              <p key={user.id} className={s.internalTeamRow}>
                {`${user.user.firstName} ${user.user.lastName} - ${user.role.label}`}{' '}
                <span
                  className={s.removeInternalTeamUser}
                  onClick={() => removeInternalTeamUser(user.id)}
                >
                  &times;
                </span>
              </p>
            ))}
          </div>
        )}
        <Select
          onChange={value => changeUserCb(value)}
          options={users}
          className={s.internalTeamUsers}
          value={internalTeam.user}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          menuPortalTarget={document.body}
        />
        <Select
          onChange={value => changeRoleCb(value)}
          options={roles}
          className={s.internalTeamRoles}
          value={internalTeam.role}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          menuPortalTarget={document.body}
        />
        <Button
          disabled={internalTeam.user === '' || internalTeam.role === ''}
          className={s.saveBtn}
          onClick={() => {
            addInternalTeamUser(internalTeam)
          }}
        >
          + Add
        </Button>
      </div>
    </>
  )
}

export default InternalTeam
